<template lang="html">
  <section class="where-group-view">
    <div :class="{ 'group-view': hasSubclauses }">
      <div
        class="where-clause"
        v-for="(item, index) in subclauses"
        :key="index"
      >
        <div class="clause" v-if="item.id">
          <div class="field">
            <span v-if="item.field">{{ item.field.label }}</span>
          </div>
          <div class="operator">
            <span v-if="item.type">{{ operators[item.type.value] }}</span>
          </div>
          <div class="expression" v-if="item.expression">
            <span>{{ item.expression.label }}</span>
          </div>
        </div>
        <div v-else>
          <where-group-view :data-element="dataElement" :clauses="item" />
        </div>
        <div v-if="subclauses.length > 1 && index !== subclauses.length - 1">
          <div class="and-or" v-if="clauseType.value === types.AND.value">
            {{ $t("and") }}
          </div>
          <div class="and-or" v-if="clauseType.value === types.OR.value">
            {{ $t("or") }}
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="js">
  import { mapState } from "vuex";
  import SfGlobalObjects from "@/utils/sf-global-objects";
  import { GROUP_CLAUSE_TYPE, DATA_ELEMENT_TYPE } from "@/static/global-variables";
  import WhereGroupView from "@/components/queries/crm-queries/WhereGroupView";
  import expressionBuilder from "@/views/drag-drop-pages/components/utils/expression-builder";
  import utils from "@/utils";

  export default  {
    name: "where-group-view",
    components: {
      WhereGroupView
    },
    props: {
      dataElement: {
        type: Object
      },
      clauses: {
        type: Object
      }
    },
    computed: {
      ...mapState({
        messages: "messages"
      }),
      operators() {
        return {
          in: this.$t("in"),
          equal: this.$t("equal"),
          "not equal": this.$t("notEqual"),
          gte: this.$t("gte"),
          lte: this.$t("lte"),
          gt: this.$t("gt"),
          lt: this.$t("lt")
        };
      },
      hasSubclauses() {
        return Boolean(this.subclauses.length);
      }
    },
    watch: {
      clauses: {
        handler() {
          this.setClauses();
          if (this.dataElement.object && this.dataElement.object.name && this.dataElement.type === DATA_ELEMENT_TYPE.CRM_QUERY) {
            SfGlobalObjects.describeObject(this.dataElement.object.name).then(
              res => {
                this.$nextTick(() => {
                  this.refreshLabels(res);
                });
              }
            );
          }
        },
        immediate: true
      }
    },
    data () {
      return {
        types: GROUP_CLAUSE_TYPE,
        clauseType: GROUP_CLAUSE_TYPE.AND,
        subclauses: []
      }
    },
    methods: {
      isBooleanDataType(clause) {
        return clause.expression.dataType === expressionBuilder.EXPRESSION_TYPE.BOOLEAN;
      },
      setClauses() {
        this.subclauses = [];
        if(this.clauses && this.clauses.type) {
          this.clauseType = this.clauses.type;
          const clauses = this.clauses.subclauses;
          if (Array.isArray(clauses)) {
            this.subclauses = clauses.map((c) => {
              if(c.id) {
                c.expression.label = utils.findExpressionLabel(c.expression);
              }
              return c;
            })
          }
        }
      },
      refreshLabels(sfObject) {
        if(sfObject) {
          const fields = sfObject.fields;
          for(const clause of this.subclauses) {

            const field = fields.find(e => clause.field && e.name === clause.field.name);
            if(field) {
              clause.field.label = field.label;
            }
          }
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "@/styles/components/main";
  @include drag-drop-a-tag;
  .where-group-view {
    box-sizing: border-box;
    position: relative;
    .group-view {
      border: 1px solid #e0e0e0;
      box-sizing: border-box;
      padding: 10px;
      margin-bottom: 3px;
      .where-clause {
        .clause {
          display: flex;
          justify-content: flex-start;
          .field {
            min-width: 22.2%;
            padding-right: 15px;
          }
          .operator {
            min-width: 22%;
            padding-right: 15px;
          }
          .expression {
            padding-right: 15px;
          }
        }
        .and-or {
          font-size: 0.7125rem;
          font-style: italic;
          color: #6b6b6b;
        }
      }
    }
  }
</style>
